import { configureStore } from '@reduxjs/toolkit';
import workflowTagsReducer from './slices/workflowTags/workflowTagsSlice';

export const store = configureStore({
  reducer: {
    workflowTags: workflowTagsReducer,
  },
});
